import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Table, Checkbox, Select, Button, Modal } from 'antd';
import './towitemgrid.css';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import swal from 'sweetalert';
import {Workbook} from 'exceljs';
import * as fs from 'file-saver';
import Translation from '../../Translation';
const Option = Select.Option;

class TowItemGrid extends React.Component {
    constructor(props) {
        super(props);
		this.myRef = React.createRef();
        this.state = {
            rows: [],
            rowsSelectPlant:[],
            rowsActive:[],
            defaultRows: [],
            selectedRowKeys: [],
            rowsFilterStatus:[],
            isViewSelectedChecked: false,
            isRowSelectedChecked : true,
            isStatusChecked: true,
            selectedRowPlant: 'All',
            selectPlant:'All',
            rowSelection: {
                onChange: this.onSelectChange,
                selectedRowKeys:[]
            },
            showTipsRodModalVisible: false,
            tipsPerRod: 0,
            toFilterTowItemData: this.props.toFilterTowItemData || {},
            btndisable: true,
            selectedLot: '',
            isPredicted: false
        }

        this.customCarbonSorter = (a, b, item) => {
            if (this.props.isCarbon) {
                return a[item].carbon - b[item].carbon;
            }
        
            return a[item].normal - b[item].normal;
        }

        this.stringSort = (a, b) => {
            if (a < b) { return -1; }
            if (a > b) { return 1; }
            return 0;
        }
        
        this.columns = this.props.isModelAnalyzer ? [
            {
                title: <Translation labelName="tbl_hdr_item" defaultText="Item"/>,
                dataIndex: 'item',
                key: 'item',
                sorter: (a,b) => this.stringSort(a['item'], b['item']),
                defaultSortOrder: 'ascend'
            },
            {
                title: <Translation labelName="tbl_hdr_lot" defaultText="Lot"/>,
                dataIndex: 'lot',
                key: 'lot',
                render: this.lotRenderer,
                sorter: (a,b) => this.stringSort(a['lot'], b['lot'])
            },
            {
                title: <Translation labelName="lbl_circumference" defaultText="Circumference"/>,
                dataIndex: 'itmcirc',
                key: 'itmcirc',
                render: this.lotRenderer,
                sorter: (a,b) => this.stringSort(a['itmcirc'], b['itmcirc'])
            },
            {
                title: <Translation labelName="tbl_hdr_minimum" defaultText="Minimum"/>,
                children: [
                    {
                        title: <Translation labelName="lbl_hdr_weight" defaultText="Weight"/>,
                        dataIndex: 'minwt',
                        key: 'minwt',
                        render: this.columnRenderer,
                        sorter: (a, b) => this.customCarbonSorter(a, b, 'minwt')
                    },
                    {
                        title:<Translation labelName="lbl_pressure_drop" defaultText="Pressure Drop"/>,
                        dataIndex: 'minpd',
                        key: 'minpd',
                        render: this.columnRenderer,
                        sorter: (a, b) => this.customCarbonSorter(a, b, 'minpd')
                    }
                ]
            },
            {
                title:<Translation labelName="tbl_hdr_maximum" defaultText="Maximum"/>,
                children: [
                    {
                        title: <Translation labelName="lbl_hdr_weight" defaultText="Weight"/>,
                        dataIndex: 'maxwt',
                        key: 'maxwt',
                        render: this.columnRenderer,
                        sorter: (a, b) => this.customCarbonSorter(a, b, 'maxwt')
                    },
                    {
                        title: <Translation labelName="lbl_pressure_drop" defaultText="Pressure Drop"/>,
                        dataIndex: 'maxpd',
                        key: 'maxpd',
                        render: this.columnRenderer,
                        sorter: (a, b) => this.customCarbonSorter(a, b, 'maxpd')
                    }
                ]
            }
        ] : [
            {
                title:<Translation labelName="tbl_hdr_item" defaultText="Item"/>,
                dataIndex: 'item',
                key: 'item',
                sorter: (a,b) => this.stringSort(a['item'], b['item']),
                defaultSortOrder: 'ascend'
            },
            {
                title:<Translation labelName="tbl_hdr_lot" defaultText="Lot"/>,
                dataIndex: 'lot',
                key: 'lot',
                render: this.lotRenderer,
                sorter: (a,b) => this.stringSort(a['lot'], b['lot'])
            },
            {
                title:<Translation labelName="tbl_hdr_minimum" defaultText="Minimum"/>,
                children: [
                    {
                        title:<Translation labelName="lbl_hdr_weight" defaultText="Weight"/>,
                        dataIndex: 'minwt',
                        key: 'minwt',
                        render: this.columnRenderer,
                        sorter: (a, b) => this.customCarbonSorter(a, b, 'minwt')
                    },
                    {
                        title:<Translation labelName="lbl_pressure_drop" defaultText="Pressure Drop"/>,
                        dataIndex: 'minpd',
                        key: 'minpd',
                        render: this.columnRenderer,
                        sorter: (a, b) => this.customCarbonSorter(a, b, 'minpd')
                    }
                ]
            },
            {
                title: <Translation labelName="tbl_hdr_maximum" defaultText="Maximum"/>,
                children: [
                    {
                        title:<Translation labelName="lbl_hdr_weight" defaultText="Weight"/>,
                        dataIndex: 'maxwt',
                        key: 'maxwt',
                        render: this.columnRenderer,
                        sorter: (a, b) => this.customCarbonSorter(a, b, 'maxwt')
                    },
                    {
                        title: <Translation labelName="lbl_pressure_drop" defaultText="Pressure Drop"/>,
                        dataIndex: 'maxpd',
                        key: 'maxpd',
                        render: this.columnRenderer,
                        sorter: (a, b) => this.customCarbonSorter(a, b, 'maxpd')
                    }
                ]
            },
            {
                title: <Translation labelName="lbl_target" defaultText="Target"/>,
                children: [
                    {
                        title: <Translation labelName="lbl_hdr_weight" defaultText="Weight"/>,
                        dataIndex: 'tgtwt',
                        key: 'tgtwt',
                        render: this.columnRenderer,
                        sorter: (a, b) => this.customCarbonSorter(a, b, 'tgtwt')
                    },
                    {
                        title: <Translation labelName="lbl_pressure_drop" defaultText="Pressure Drop"/>,
                        dataIndex: 'tgtpd',
                        key: 'tgtpd',
                        render: this.columnRenderer,
                        sorter: (a, b) => this.customCarbonSorter(a, b, 'tgtpd')
                    }
                ]
            },
            {
                title:<Translation labelName="load_items_tbl_hdr_point_range" defaultText="Point In Range"/>,
                dataIndex: 'pir',
                key: 'pir',
                render: this.columnRenderer,
                sorter: (a, b) => this.customCarbonSorter(a, b, 'pir')
            },
            {
                title:<Translation labelName="lbl_firmness" defaultText="Firmness"/>,
                dataIndex: 'firmness',
                key: 'firmness',
                sorter: (a, b) => {
                    return a.firmness - b.firmness;
                }
            },
            {
                title:<Translation labelName="lbl_weight_range" defaultText="Weight Range"/>,
                dataIndex: 'rangeextn',
                key: 'rangeextn',
                render: this.columnRenderer,
                sorter: (a, b) => this.customCarbonSorter(a, b, 'rangeextn')
            },
            {
                title:<Translation labelName="lbl_max_carbon_load" defaultText="Max Carbon Load"/>,
                dataIndex: 'crange',
                render: (val, row) => {
                    return (
                        row.cload && 
                        <p className="carbon">{parseFloat(val).toFixed(2)}</p>
                    )
                },
                sorter: (a, b) => {
                    return a.crange - b.crange;
                }
            },
            {
                title:<Translation labelName="lbl_action" defaultText="Action"/>,
                key: 'action',
                render: (rec) => (
                    <span>
                        <a className="action-link" href="#" onClick={(e) => this.showTipsRodInputModal(e, rec)}><Translation labelName="lbl_to_filter" defaultText="To Filter"/></a>
                    </span>
                ),
            }
        ];
        
        this.toggleViewSelectedCheck = this.toggleViewSelectedCheck.bind(this);
        this.getSelectedItems = this.getSelectedItems.bind(this);
        this.viewSelectedItems = this.viewSelectedItems.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.toggleStatusCheck = this.toggleStatusCheck.bind(this);
        this.JSONToXLSXConvertor = this.JSONToXLSXConvertor.bind(this);
    }

    viewSelectedItems(selectedItems) {
        const itemLotsProps = selectedItems;
        const itemLotsArr = itemLotsProps.length ? (
            itemLotsProps.map(function (item) {
                return item.itemlot || item;
            })
        ) : (
                []
            );

        this.setState({
            selectedRowKeys: itemLotsArr,
            rowSelection: {
                selectedRowKeys: itemLotsArr,
                onChange: this.onSelectChange
            }
        });
    }

    toggleViewSelectedCheck () {
        this.setState({ isViewSelectedChecked: !this.state.isViewSelectedChecked }, function () {
            if (this.state.isViewSelectedChecked) {               
                this.getSelectedItems();
            }
            else {
                if(this.state.rows.length > 0){
                    if(this.state.rowsSelectPlant.length > 0){
                        this.setState({
                            rows: this.state.rowsSelectPlant,
                            isRowSelectedChecked: true
                        });
                    }else{
                        this.setState({
                            rows: this.state.rows,
                            isRowSelectedChecked: true
                        });
                    }
                }
                else{
                    this.setState({
                        rows: this.props.towItems,
                        rowSelection: {
                            selectedRowKeys: this.state.selectedRowKeys,
                            onChange: this.onSelectChange,
                            isRowSelectedChecked: true
                        }
                    }); 
                }
                
            }
            if(this.state.selectedRowKeys.length > 0){
                this.setState({
                    isRowSelectedChecked: false
                });
            }
        });
    }

    getSelectedItems() {
        var data = this.props.towItems;
        if(this.state.rows.length > 0){
            data = this.props.towItems;
            console.log('this.props.towItems')
        }
        let selectedItems = this.state.selectedRowKeys;
        var finalArr = [];
        for (let item of selectedItems) {
            let result = data.find(element => element.itemlot === item);
            finalArr = finalArr.concat(result);
        }
        this.setState({
            rows: finalArr
        });
    }

    columnRenderer = (vals,row) => {
        return (
            <div>
                {row.cload &&
                <p className="carbon">{vals.carbon}</p>
                }
                <p>{vals.normal}</p>
            </div>
        );
    }

    lotRenderer = (val, row) => {
        return (
            <span className={row.status===false?'text-danger-tag' : ''}>
                {val}
            </span>
        );
    }

    componentWillMount() {
        let selectedItems = [];
        //if(selectedItems.length) {
            this.viewSelectedItems(selectedItems);
        // }
        
        this.setState({
            isViewSelectedChecked: false
        });
    }

    componentWillReceiveProps(newProps){
        let filteredArr = [];
        if(newProps && newProps.towItems) {
            if(this.state.selectPlant === 'All'){
                for(let i=0; i< newProps.towItems.length; i++){
                    if(newProps.towItems[i].status){
                        filteredArr.push(newProps.towItems[i]);
                    }
                }
            }else{
                for(let i=0; i< newProps.towItems.length; i++){
                    if(newProps.towItems[i].status && newProps.towItems[i].plant === this.state.selectPlant){
                        filteredArr.push(newProps.towItems[i]);
                    }
                }
            }
        }

        if(newProps.toFilterTowItemData && newProps.toFilterTowItemData !== this.state.toFilterTowItemData) {
            this.setState({
                toFilterTowItemData: newProps.toFilterTowItemData || {}
            });
        }
        
        this.setState({ 
            rows: filteredArr,
            rowsSelectPlant: filteredArr,
            isStatusChecked: false,
            selectedRowPlant:'All',
            rowSelection: {
                onChange: this.onSelectChange,
                type: newProps.isCarbon ? 'radio' : 'checkbox'
            }
        },function(){
            if(typeof newProps.loadItemsClick === 'boolean'){
                this.setState({ 
                    rowSelection: {
                        onChange: this.onSelectChange,
                        selectedRowKeys: newProps.loadItemsClick ? [] : this.state.selectedRowKeys,
                        type: newProps.isCarbon ? 'radio' : 'checkbox'
                    } 
                });
                if(newProps.loadItemsClick){
                    this.setState({ isViewSelectedChecked:false,selectedRowKeys:[]},function(){
                        this.setState({ isRowSelectedChecked:true});
                    });
                }
                else if(this.state.isViewSelectedChecked){
                    this.getSelectedItems();
                }
            } 
            if(this.state.selectedRowKeys.length === 0){
                this.setState({ 
                    isRowSelectedChecked: true,
                    isViewSelectedChecked: false
                });
            }
        });
        if (this.myRef.current.getPopupContainer) {
            let container = this.myRef.current.getPopupContainer();
            container.querySelector('.ant-table-body').scroll ? container.querySelector('.ant-table-body').scroll(0,0) : container.querySelector('.ant-table-body').scrollTop = 0;
        }
    }

    onSelectChange = (selectedRowKeys,rows) => {
        this.setState({ 
            selectedRowKeys,
            isRowSelectedChecked: false,
            rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                type: this.props.isCarbon ? 'radio' : 'checkbox'
            }
        });
        if(selectedRowKeys.length === 0){
            this.setState({ 
                isRowSelectedChecked: true
            });
        }
        if(rows) {
            this.props.onTowItemsSelected(rows);
        }
    }

    handleSelectChange(val) {
        let filteredArr = [];
        let arr = this.props.towItems ? this.props.towItems: [];
        let selectedKeys = [];
        this.onSelectChange(selectedKeys);
        this.setState({
            selectPlant: val
        });
        if(val === 'All'){
            if(!this.state.isStatusChecked){
                for(let i=0; i< arr.length; i++){
                    if(arr[i].status){
                        filteredArr.push(arr[i]);
                    }
                }
                this.setState({
                    rows: filteredArr,
                    rowsSelectPlant: filteredArr,
                    selectedRowPlant: val
                });
            }
            else {
                this.setState({
                    rows: this.props.towItems,
                    rowsSelectPlant: this.props.towItems
                });
            }
             
        }
        else{
            if(!this.state.isStatusChecked){
                for(let i=0; i< arr.length; i++){
                    if(arr[i].status && arr[i].plant === val){
                        filteredArr.push(arr[i]);
                    }
                }
            }
            else {
                for(let i=0; i< arr.length; i++){
                    if(arr[i].plant === val){
                        filteredArr.push(arr[i]);
                    }
                }
            }
            this.setState({
                rows: filteredArr,
                rowsSelectPlant: filteredArr,
                selectedRowPlant: val
                
            });
        }
        this.props.onTowItemsSelected([]);
        this.setState({ isViewSelectedChecked:false});
    }

    toggleStatusCheck(){
        let filteredArr = [];
        this.setState({ isStatusChecked: !this.state.isStatusChecked }, function () {
        
            if (!this.state.isStatusChecked) {
                let filteredArr = [];
                let arr = this.state.rows.length > 0 ? this.state.rows: this.props.towItems;
                for(let i=0; i< arr.length; i++){
                    if(arr[i].status){
                        filteredArr.push(arr[i]);
                    }
                }
                this.setState({
                    rows: filteredArr,
                    rowsFilterStatus: filteredArr
                });
            }
            else{
                if (this.state.selectedRowPlant !== 'All'){
                    for(let i=0; i< this.props.towItems.length; i++){
                        if(this.props.towItems[i].plant === this.state.selectedRowPlant){
                            filteredArr.push(this.props.towItems[i]);
                        }
                    }
                    this.setState({
                        rows: filteredArr,
                        rowsSelectPlant: filteredArr
                    });   
                }
                else{
                    this.setState({
                        rows: this.props.towItems
                    }); 
                }
            }
        });
    }

    exportFile=(e)=> {
        e.preventDefault();
        if (this.state.rows.length === 0) {
            swal({
                text: 'Database has zero tow items, Do you want to continue to export with empty tow items?',
                buttons: ['NO', 'YES']
            }).then((action) => {
                if (action) {
                    this.downloadFile();
                }
            });
        } else {
            this.downloadFile();
        }

    }

    downloadFile=()=> {
        this.JSONToXLSXConvertor(this.state.rows? this.state.rows: this.props.towItems, "Selected Tow items");
    }

    JSONToXLSXConvertor(JSONData) {
        let workbook = new Workbook();
        let worksheet = workbook.addWorksheet('TowItems');
        let today = new Date();
        let dd = today.getDate();

        let mm = today.getMonth()+1; 
        let yyyy = today.getFullYear();
        if (dd < 10) {
            dd=`0${dd}`;
        } 

        if (mm < 10) {
            mm=`0${mm}`;
        } 

        swal({
            title:'Fetching tow items',
            text: 'Download will start in few seconds...',
            buttons: false,
            toast: true
        });

        const finalObject = (input) => {
            let obj ={
                'item': input.item,
                'lot': input.lot,                                
                'min_weight': input.minwt.normal,                
                'min_pressure_drop': input.minpd.normal,                
                'max_weight': input.maxwt.normal,                
                'max_pressure_drop': input.maxpd.normal,                
                'target_weight': input.tgtwt.normal,                
                'target_pressure_drop': input.tgtpd.normal,
                'range_extension': input.rangeextn.normal,                
                'pir': input.pir.normal,                
                'firmness': input.firmness
            }

            if (this.props.isCarbon) {
                obj = Object.assign({}, obj, {
                    'carbon_load': input.cload,
                    'carbon_min_weight': input.minwt.carbon,
                    'carbon_min_pressure_drop': input.minpd.carbon,
                    'carbon_max_weight': input.maxwt.carbon,
                    'carbon_max_pressure_drop': input.maxpd.carbon,
                    'carbon_target_weight': input.tgtwt.carbon,
                    'carbon_target_pressure_drop': input.tgtpd.carbon,
                    'carbon_range_extension': input.rangeextn.carbon,
                    'carbon_pir': input.pir.carbon,
                    'max_carbon_load': input.crange
                })
            }

            return obj;

        }
        let headers = [];
        Object.keys(finalObject(JSONData[0])).forEach((headerKey)=>{
            headers.push({
                name: headerKey,
                key: headerKey,
                filterButton: true
            })
        });

        let rows = [];

        JSONData.map(function(data) {
            rows.push(Object.values(finalObject(data)));
            return true;
        });


        worksheet.addTable({
            name: 'MyTable',
            ref: 'A1',
            headerRow: true,
            totalsRow: false,
            style: {
                theme: 'TableStyleMedium7',
                showRowStripes: true,
            },
            columns: headers,
            rows: rows
        });
       
        worksheet.views = [
            {
                state: 'frozen',
                xSplit: 0,
                ySplit: 1
            }
        ]

        workbook.xlsx.writeBuffer().then((data)=>{
            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, `celanese-tow-items-${mm}${dd}${yyyy}.xlsx`);
            setTimeout(function(){
                swal.close();
            },500);
        });

    }
    
    showTipsRodInputModal = (e, rec) => {
        e.preventDefault();
        this.setState({
            showTipsRodModalVisible: true,
            selectedLot: rec.itemlot,
            isPredicted: rec.lot && rec.lot.toLowerCase() === 'predicted'
        });
    }
    
    hideTipsRodInputModal = () => {
        this.setState({
            showTipsRodModalVisible: false
        });
    }

    handleInputChange = (e) => {
        const val = e.target.value;
        if(parseInt(val, 10) > 0 && parseInt(val, 10) <= 100) {
            this.setState({
                [e.target.id]: val,
                btndisable: false
            });
        } else {
            this.setState({
                btndisable: true
            });
        }
    }

    render() {
        let profileData = this.props.prefData;
        let azureProfileData = profileData ? profileData.profile.azureProfile : '';
        let { isPredicted, selectedLot } = this.state;
        let toFilterTowItemVal = selectedLot;
        if(isPredicted) {
            toFilterTowItemVal = '';
        }
        return (
            <div className="tow-items-wrapper">
                <a href="" download="" className="selected-towitems-hidden" id="selected-towitems-link"></a>
                {
                    !this.props.isModelAnalyzer ? (
                        <div className="tow-items__selected">
                            <div className="col-md-5 flush-right flush-left">
                                { azureProfileData && (azureProfileData.role.toLocaleLowerCase() === 'admin' || azureProfileData.role.toLocaleLowerCase() === 'ce-user') ? (<div className="plantcode-container">
                                    <label className="select-label"><Translation labelName="lbl_plant" defaultText="Plant" /> :</label>
                                    <Select
                                        placeholder="All"
                                        value={this.state.selectPlant}
                                        onChange={(value) => this.handleSelectChange(value)}
                                        >
                                        <Option value="All"><Translation labelName="txt_all" defaultText="All"/></Option>
                                        <Option value="C"><Translation labelName="txt_celco" defaultText="Celco"/></Option>
                                        <Option value="O"><Translation labelName="txt_ocotlan" defaultText="Ocotlan"/></Option>
                                        <Option value="L"><Translation labelName="txt_lanaken" defaultText="Lanaken"/></Option>
                                        <Option value="S"><Translation labelName="txt_spondon" defaultText="Spondon"/></Option>
                                    </Select>
                                </div>) : null }
                                <p className="select-label margin-left-none">
                                    <Translation labelName="lbl_showing" defaultText="Showing" /> : { this.state.rows && this.state.rows.length > 0 && <span>{this.state.rows.length} <Translation labelName="lbl_tow_items" defaultText="Tow Items" /></span> }
                                </p>
                            </div>
                            <div className="col-md-7 filter-select flush-left text-right">
                                <Checkbox
                                    className={this.state.isViewSelectedChecked ? "displayNone" : "displayBlock"}
                                    onChange={this.toggleViewSelectedCheck}
                                    disabled={this.state.isRowSelectedChecked}
                                    checked={this.state.isViewSelectedChecked}><Translation labelName="chk_view_selected" defaultText="View Selected Items"/></Checkbox> 
                                { azureProfileData && (azureProfileData.role.toLocaleLowerCase() === 'admin' || azureProfileData.role.toLocaleLowerCase() === 'ce-user') ?
                                    (<Checkbox
                                        onChange={this.toggleStatusCheck}
                                        checked={this.state.isStatusChecked}
                                    ><Translation labelName="chk_Include_Inactive_Items" defaultText="Include Inactive Items"/></Checkbox>) : null }
                                    <Button type="primary" shape="circle" icon="download" size="small" onClick={(e) => this.downloadFile(e)} />
                            </div>
                        </div>
                    ) : null
                }
                <Table 
					ref={this.myRef}
                    className={'tow-items-table'}
                    rowSelection={this.state.rowSelection}
                    scroll={{y:this.props.tableHeight-125, x:1250}}
                    rowKey="itemlot"
                    columns={this.columns}
                    dataSource={this.state.rows}
                    size="small"
                    bordered
                    pagination={false}
                />
                { this.state.showTipsRodModalVisible ? <Fragment>
                    <Modal 
                        visible={this.state.showTipsRodModalVisible}
                        footer={null}
                        onCancel={this.hideTipsRodInputModal}
                        centered
                        width={400}>
                        <Fragment>
                            <h3><Translation labelName="lbl_tips_per_rod " defaultText="Tips per Rod"/></h3>
                            <label><Translation labelName="load_items_tbl_mdl_lbl_selected_lot" defaultText="Selected Lot"/><span>{this.state.selectedLot}</span></label>
                            <input
                                type="number"
                                id="tipsPerRod"
                                autoComplete="off"
                                className="select-tips-link"
                                onChange={(e) => this.handleInputChange(e)} />
                            <Button type="primary" disabled={this.state.btndisable} className="btn btn-default select-tips-btn" loading={this.state.loading}>
                                <Link to={{ pathname: '/filter-cigarette-design', state: { tipsPerRod: this.state.tipsPerRod, toFilterTowItemData: this.state.toFilterTowItemData, toFilterTowItemVal: toFilterTowItemVal, isPredicted: this.state.isPredicted } }}><Translation labelName="lbl_to_filter" defaultText="To Filter"/></Link>
                            </Button>
                        </Fragment>
                    </Modal>
                </Fragment> : null }
            </div>
        );
    }
}


TowItemGrid.propTypes = {
    towItemFormData: PropTypes.object,
    onTowItemsSelected: PropTypes.func,
    towItems: PropTypes.array,
    tableHeight:PropTypes.number,
    isCarbon: PropTypes.bool,
    prefData: PropTypes.object,
    loadItemsClick: PropTypes.bool,
    isPropsData: PropTypes.bool,
    toFilterTowItemData: PropTypes.object,
    isModelAnalyzer: PropTypes.bool
};

const mapStateToProps = ({ loggedUserState }) => ({
    prefData: loggedUserState.prefData
});

export default connect(mapStateToProps, null)(TowItemGrid);



// WEBPACK FOOTER //
// ./src/containers/TowItemGrid/index.js